"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notification = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _buttonClose = require("../button-close/button-close");
var iconSet = {
  info: /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#26262b",
    fillRule: "evenodd",
    d: "m16 8c0-4.41828-3.5817-8-8-8-4.41828 0-8 3.58172-8 8 0 4.4183 3.58172 8 8 8 4.4183 0 8-3.5817 8-8zm-9-.5c0-.55228.44771-1 1-1 .5523 0 1 .44772 1 1v5c0 .5523-.4477 1-1 1-.55229 0-1-.4477-1-1zm1-5c-.69036 0-1.25.55964-1.25 1.25s.55964 1.25 1.25 1.25c.6904 0 1.25-.55964 1.25-1.25s-.5596-1.25-1.25-1.25z",
    transform: "translate(2 2)"
  })),
  warning: /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#26262b",
    fillRule: "evenodd",
    d: "m8 16c-4.41828 0-8-3.5817-8-8 0-4.41828 3.58172-8 8-8 4.4183 0 8 3.58172 8 8 0 4.4183-3.5817 8-8 8zm-1.25-4.25c0 .6904.55964 1.25 1.25 1.25.6904 0 1.25-.5596 1.25-1.25s-.5596-1.25-1.25-1.25c-.69036 0-1.25.5596-1.25 1.25zm.25-3.75c0 .5523.44772 1 1 1 .5523 0 1-.4477 1-1v-4c0-.55228-.4477-1-1-1-.55228 0-1 .44772-1 1z",
    transform: "translate(2 2)"
  })),
  danger: /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "20",
    viewBox: "0 0 20 20",
    width: "20"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#26262b",
    fillRule: "evenodd",
    d: "m8 16c-4.41828 0-8-3.5817-8-8 0-4.41828 3.58172-8 8-8 4.4183 0 8 3.58172 8 8 0 4.4183-3.5817 8-8 8zm-5-8c0-.55229.44772-1 1-1h8c.5523 0 1 .44772 1 1 0 .5523-.4477 1-1 1h-8c-.55228 0-1-.4477-1-1z",
    transform: "translate(2 2)"
  })),
  success: /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m17.5259 4.4057c.6044.56659.635 1.51585.0684 2.12022l-7.5 7.99998c-.27782.2964-.66396.4674-1.07012.4739-.40616.0066-.79761-.1519-1.08484-.4391l-3.5-3.5c-.58579-.5858-.58579-1.53557 0-2.12136.58579-.58578 1.53553-.58578 2.12132 0l2.40457 2.40456 6.44047-6.86981c.5666-.60437 1.5158-.63499 2.1202-.06839z"
  }))
};
var typeClasses = {
  info: 'notification_info',
  warning: 'notification_warning',
  danger: 'notification_danger',
  success: 'notification_success'
};
var Notification = exports.Notification = function Notification(props) {
  var children = props.children,
    type = props.type,
    _props$size = props.size,
    size = _props$size === void 0 ? 'lg' : _props$size,
    _props$itemsAlignment = props.itemsAlignment,
    itemsAlignment = _props$itemsAlignment === void 0 ? 'center' : _props$itemsAlignment,
    onClose = props.onClose,
    closeButtonAriaLabel = props.closeButtonAriaLabel,
    withIcon = props.withIcon,
    wideEdges = props.wideEdges;
  var notificationClasses = (0, _classnames["default"])('notification', typeClasses[type], {
    'notification_with-icon': withIcon,
    'notification_wide-edges': wideEdges,
    'notification_dismissable': onClose,
    'notification_align-center': itemsAlignment === 'center',
    'notification_fit-content': size === 'sm'
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    role: "alert",
    className: notificationClasses
  }, withIcon && /*#__PURE__*/_react["default"].createElement("div", {
    className: "notification__icon"
  }, iconSet[type]), /*#__PURE__*/_react["default"].createElement("div", {
    className: "notification__main"
  }, children), onClose && /*#__PURE__*/_react["default"].createElement("div", {
    className: "notification__button-close"
  }, /*#__PURE__*/_react["default"].createElement(_buttonClose.ButtonClose, {
    onClick: onClose,
    ariaLabel: closeButtonAriaLabel,
    size: "sm"
  })));
};

// is only needed to avoid snapshots updating
Notification.defaultProps = {
  withIcon: false,
  wideEdges: false,
  onClose: null,
  closeButtonAriaLabel: undefined
};